/**
 * Consent texts indexed by `samtykkeId.value`.
 *
 * The back-end response only provides `tittel` and an (often empty) `tekster`
 * array, so the display label and the explanatory modal texts are resolved
 * locally from this map. If an id is missing here we fall back to the `tittel`
 * from the back-end response.
 */
export interface ConsentText {
    /** Short label shown next to the Ja/Nei toggle. */
    label: string;
    /** Title shown in the "what does this mean" modal. */
    modalTitle: string;
    /** One or more paragraphs explaining the consent in more detail. */
    modalText: string[];
}

export type ConsentTextMap = Record<string, ConsentText>;

const consentTexts: ConsentTextMap = {
    CONSENT_MARKETING_SMS: {
        label: 'Jeg ønsker råd og tilbud på SMS',
        modalTitle: 'Råd og tilbud på SMS',
        modalText: [
            'Ved å samtykke lar du banken sende deg råd, tips og tilbud på SMS.',
            'Du kan når som helst trekke tilbake samtykket ved å endre innstillingene i nettbanken eller ved å kontakte banken.',
        ],
    },
    CONSENT_MARKETING_EMAIL: {
        label: 'Jeg ønsker råd og tilbud på e-post',
        modalTitle: 'Råd og tilbud på e-post',
        modalText: [
            'Ved å samtykke lar du banken sende deg råd, tips og tilbud på e-post.',
            'Du kan når som helst trekke tilbake samtykket ved å endre innstillingene i nettbanken eller ved å kontakte banken.',
        ],
    },
    CONSENT_CUSTOMIZED_MARKETING: {
        label: 'Jeg ønsker tilpassede råd og tilbud',
        modalTitle: 'Tilpassede råd og tilbud',
        modalText: [
            'Ved å samtykke lar du banken bruke opplysningene den har om deg til å gi deg mer relevante og tilpassede råd og tilbud.',
            'Du kan når som helst trekke tilbake samtykket ved å endre innstillingene i nettbanken eller ved å kontakte banken.',
        ],
    },
    RESERVATION_NON_DIGITAL_CUSTOMER: {
        label: 'Jeg ønsker alle meldinger fra banken som brevpost',
        modalTitle: 'Meldinger som brevpost',
        modalText: ['Ved å velge dette vil du motta alle meldinger fra banken som brevpost i stedet for digitalt.'],
    },
    RESERVATION_NO_DIGITAL_COMMUNICATION: {
        label: 'Jeg ønsker ikke å motta informasjon fra banken digitalt',
        modalTitle: 'Digital kommunikasjon',
        modalText: ['Ved å velge dette reserverer du deg mot å motta informasjon fra banken digitalt.'],
    },
    RESERVATION_NO_PHONE_MARKETING: {
        label: 'Jeg ønsker ikke at banken ringer meg med gode tilbud',
        modalTitle: 'Markedsføring på telefon',
        modalText: ['Ved å velge dette reserverer du deg mot at banken kontakter deg på telefon med råd og tilbud.'],
    },
};

export const getConsentText = (samtykkeIdValue: string): ConsentText | undefined => consentTexts[samtykkeIdValue];

export default consentTexts;
